/**
 * Política de indexação — noindex para imóveis/condomínios indisponíveis.
 */

export const DEFAULT_ROBOTS =
  'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1';
export const NOINDEX_ROBOTS = 'noindex,nofollow';

const NON_INDEXABLE_STATUSES = new Set([
  'Indisponível',
  'Vendido',
  'Alugado',
  'Cancelado',
]);

export function isListingIndexable(entity) {
  if (!entity) return true;
  if (entity.isAvailable === false) return false;
  if (entity.isInactive === true) return false;
  if (entity.soldOrRented === true) return false;
  if (entity.propertyStatus && NON_INDEXABLE_STATUSES.has(entity.propertyStatus)) {
    return false;
  }
  return true;
}

export function resolveSeoRobots(entity, robotsOverride = null) {
  if (robotsOverride && robotsOverride !== DEFAULT_ROBOTS) {
    return robotsOverride;
  }
  if (entity && !isListingIndexable(entity)) {
    return NOINDEX_ROBOTS;
  }
  return DEFAULT_ROBOTS;
}

/** Robots para posts do blog (rascunhos e noindex manual). */
export function resolveBlogSeoRobots(blogPost, robotsOverride = null) {
  if (robotsOverride) return robotsOverride;
  if (!blogPost) return DEFAULT_ROBOTS;
  if (blogPost.status === 'draft') return NOINDEX_ROBOTS;
  const parts = [blogPost.robotsIndex === 'noindex' ? 'noindex' : 'index'];
  parts.push(blogPost.robotsFollow === false ? 'nofollow' : 'follow');
  if (blogPost.robotsIndex !== 'noindex') {
    parts.push('max-image-preview:large', 'max-snippet:-1', 'max-video-preview:-1');
  }
  if (blogPost.robotsArchive) parts.push('noarchive');
  return parts.join(',');
}
